import React, {useEffect,useState,useCallback,useContext ,useMemo, useRef} from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import styles from './css/user.module.css';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DataTable from "react-data-table-component";
import $ from 'jquery';
import RefreshContext from './RefreshContext';
import {
  Box, 
   Button, 
  Select as MuiSelect,
  MenuItem, 
  Typography, 
  Tooltip, 
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Menu,Checkbox} from '@mui/material'; 
import { ArrowDropDown, ArrowDropUp, MoreVert as MoreVertIcon,DeleteOutline, EditOutlined, VisibilityOutlined, KeyboardArrowRight, FormatListBulleted, PeopleAltOutlined, AssignmentOutlined, ArrowBackIosNew } from '@mui/icons-material';


function LineCandidate(){
const navigate = useNavigate();
const { aid ,aidtype} = useParams();
const [staff,setStaff]= useState([]);
const [total,setTotal]= useState(0);
const [ivrdata,setIvrData] = useState("");
const [ivr,setIvr] = useState("");
const [bankVerifyData, setBankVerifyData] = useState("");
const [bankVerifyIvr, setBankVerifyIvr] = useState("");
const [contracts, setContractOptions] = useState([]);
const [selectBank, setBank] = useState(null);
const [selectContract, setContract] = useState(null);
const [selectblood, setBlood] = useState(null);
const [selectSalu, setSalutation] = useState(null);
const [contractEndDate, setContractEndDate] = useState("");
const [currentStep, setCurrentStep] = useState(1);
const [isEditable, setIsEditable] = useState(false);
const [allDocsUploaded, setAllDocsUploaded] = useState(false);
const inputRef = useRef(null);
const fileRefs = useRef({});
const totalSteps = 2;
const [documents, setDocuments] = useState({
  1: { file: null, preview: "", uploaded: false, type: "" },
  2: { file: null, preview: "", uploaded: false, type: "" },
  3: { file: null, preview: "", uploaded: false, type: "" },
  4: { file: null, preview: "", uploaded: false, type: "" }
});

const [selectedCandidate, setSelectedCandidate] = useState(null);

const [loadings, setTableLoading] = useState(true);
const [newloading,setNewLoading] = useState(false);
const { refreshKey } = useContext(RefreshContext);
const [requirement, setRequirement] = useState(null);
    
const [order, setOrder] = useState('asc'); 
const [orderBySelector, setOrderBySelector] = useState(() => (row) => row.rid); 
const [globalFilterText, setGlobalFilterText] = useState('');
const [columnFilters, setColumnFilters] = useState({});


const [metaData, setMetaData] = useState({
  appname: '',
  edit: false,
  del: false,
  add: false,
  view: false,
  typess:'',
  icon:'',
  checkbox:0,
  defaultShow:'',
  recname:'',
  jobtitle:'',
  location:'',
  require:''
});

const interviewStatusOptions = [
    { value: 'pending', label: 'Pending' },
    { value: 'success', label: 'Selected' },
    { value: 'decline', label: 'Rejected' },
];

const joinStatusOptions = [
    { value: 'success', label: 'Joined' },
    { value: 'pending', label: 'Not Joined' },
];

const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
];

const sourceOptions = [
    { value: 'source', label: 'Source' },
    { value: 'transfer', label: 'Transfer' },
];

const napsStaffingOptions = [
    { value: 'naps', label: 'NAPS' },
    { value: 'staffing', label: 'Staffing' },
    { value: 'B.VOC', label: 'B.VOC' },
];

const documentStatusOptions = [
    { value: 'pending', label: 'Pending' },
    { value: 'receiveed', label: 'Received' },
];

const saluationType = [
  { value: 'Mr.', label: 'Mr.' },
  { value: 'Mrs.', label: 'Mrs.' },
  { value: 'Ms.', label: 'Ms.' },
  { value: 'Dr.', label: 'Dr.' },
  { value: 'Prof.', label: 'Prof.' },
  { value: 'Mx.', label: 'Mx.' }
];

const bloodGroupType = [
  { value: 'A+', label: 'A+' },
  { value: 'A-', label: 'A-' },
  { value: 'B+', label: 'B+' },
  { value: 'B-', label: 'B-' },
  { value: 'AB+', label: 'AB+' },
  { value: 'AB-', label: 'AB-' },
  { value: 'O+', label: 'O+' },
  { value: 'O-', label: 'O-' }
];

const BankOptions = [
  { value: 'sbi', label: 'State Bank of India' },
  { value: 'bank_of_baroda', label: 'Bank of Baroda' },
  { value: 'punjab_national_bank', label: 'Punjab National Bank' },
  { value: 'canara_bank', label: 'Canara Bank' },
  { value: 'union_bank_of_india', label: 'Union Bank of India' },
  { value: 'bank_of_india', label: 'Bank of India' },
  { value: 'indian_bank', label: 'Indian Bank' },
  { value: 'central_bank_of_india', label: 'Central Bank of India' },
  { value: 'indian_overseas_bank', label: 'Indian Overseas Bank' },
  { value: 'uco_bank', label: 'UCO Bank' },
  { value: 'bank_of_maharashtra', label: 'Bank of Maharashtra' },
  { value: 'punjab_and_sind_bank', label: 'Punjab & Sind Bank' },
  { value: 'hdfc_bank', label: 'HDFC Bank' },
  { value: 'icici_bank', label: 'ICICI Bank' },
  { value: 'axis_bank', label: 'Axis Bank' },
  { value: 'kotak_mahindra_bank', label: 'Kotak Mahindra Bank' },
  { value: 'indusind_bank', label: 'IndusInd Bank' },
  { value: 'yes_bank', label: 'YES Bank' },
  { value: 'idfc_first_bank', label: 'IDFC FIRST Bank' },
  { value: 'federal_bank', label: 'Federal Bank' },
  { value: 'south_indian_bank', label: 'South Indian Bank' },
  { value: 'karnataka_bank', label: 'Karnataka Bank' },
  { value: 'karur_vysya_bank', label: 'Karur Vysya Bank' },
  { value: 'jammu_and_kashmir_bank', label: 'Jammu & Kashmir Bank' },
  { value: 'csb_bank', label: 'CSB Bank' },
  { value: 'city_union_bank', label: 'City Union Bank' },
  { value: 'dcb_bank', label: 'DCB Bank' },
  { value: 'dhanlaxmi_bank', label: 'Dhanlaxmi Bank' },
  { value: 'nainital_bank', label: 'Nainital Bank' },
  { value: 'rbl_bank', label: 'RBL Bank' },
  { value: 'tamilnad_mercantile_bank', label: 'Tamilnad Mercantile Bank' },
  { value: 'andhra_pradesh_grameena_bank', label: 'Andhra Pradesh Grameena Bank' },
  { value: 'arunachal_pradesh_rural_bank', label: 'Arunachal Pradesh Rural Bank' },
  { value: 'assam_gramin_vikash_bank', label: 'Assam Gramin Vikash Bank' },
  { value: 'bihar_gramin_bank', label: 'Bihar Gramin Bank' },
  { value: 'chhattisgarh_rajya_gramin_bank', label: 'Chhattisgarh Rajya Gramin Bank' },
  { value: 'uttar_pradesh_gramin_bank', label: 'Uttar Pradesh Gramin Bank' }
];

const handleBankVerifyReset = () => {
  setBank(null);
  setSalutation(null);
  setBlood(null);
  setContract(null);
  setContractEndDate("");
  setAllDocsUploaded(false);
  setCurrentStep(1);
  setIsEditable(false);
  setDocuments({
    1: { file: null, preview: "", uploaded: false, type: "" },
    2: { file: null, preview: "", uploaded: false, type: "" },
    3: { file: null, preview: "", uploaded: false, type: "" },
    4: { file: null, preview: "", uploaded: false, type: "" }
  });
};


 const [selected, setSelected] = useState({
    profile: null,
    location: null,
    interview: null,
  });
  const dynamicFilterOptions = useMemo(() => {
            const options = {};
            const selectAccessors = ['location','designation','exp'];
            
            selectAccessors.forEach(key => {
                const uniqueValues = new Set();
                staff.forEach(row => {
                    if (row[key]) {
                        uniqueValues.add(row[key]);
                    }
                });
                options[key] = Array.from(uniqueValues).sort();
            });
            return options;
        }, [staff]);
    
  const shouldIncludeActionColumn = (
            metaData.typess?.toUpperCase() === "ADMIN" || metaData.typess?.toUpperCase() === "VENDOR" ||
            metaData.del === 1 ||
            metaData.view === 1 ||
            metaData.add === 1 ||
            metaData.edit === 1 ||
            metaData.bd === 1
    );

useEffect(() => {
  if (isEditable && inputRef.current) {
    inputRef.current.focus();
  }
}, [isEditable]);

useEffect(() => {
  if (!bankVerifyData) return;

  if (bloodGroupType.length > 0 && bankVerifyData.blood) setBlood(bankVerifyData.blood);
  if (saluationType.length > 0 && bankVerifyData.salu) setSalutation(bankVerifyData.salu);
  if (BankOptions.length > 0 && (bankVerifyData.bank || bankVerifyData.bankname)) {
    setBank(bankVerifyData.bank || bankVerifyData.bankname);
  }
  if (contracts.length > 0 && bankVerifyData.contract) {
    setContract(bankVerifyData.contract);
    const selectedContract = contracts.find((item) => item.value === bankVerifyData.contract);
    setContractEndDate(selectedContract ? selectedContract.end_date : "");
  }
}, [bankVerifyData, contracts]);

useEffect(() => {
  const requiredDone = (documents[1]?.uploaded || !!documents[1]?.preview) && (documents[2]?.uploaded || !!documents[2]?.preview);
  setAllDocsUploaded(requiredDone);
}, [documents]);

const validateBankStep = (stepNumber) => {
  const wrapper = document.querySelector("#bankVerifyModal");
  if (!wrapper) return false;

  let valid = true;
  let emptyFields = [];
  const requiredFields = wrapper.querySelectorAll(`.form-step[data-step="${stepNumber}"] [required]`);

  requiredFields.forEach((input) => {
    let errorSpan = input.nextElementSibling;
    if (!input.value.trim()) {
      valid = false;
      const label = input.closest("div")?.querySelector("label")?.innerText || input.name || "Field";
      emptyFields.push(label.trim());

      if (errorSpan && errorSpan.classList.contains("error-text")) {
        errorSpan.remove();
      }
      const span = document.createElement("span");
      span.textContent = "Empty";
      span.className = "error-text";
      span.style.color = "red";
      span.style.fontSize = "10px";
      span.style.paddingLeft = "4px";
      input.insertAdjacentElement("afterend", span);
    } else if (errorSpan && errorSpan.classList.contains("error-text")) {
      errorSpan.remove();
    }
  });

  const reactSelects = wrapper.querySelectorAll(`.form-step[data-step="${stepNumber}"] .react-select-required`);
  reactSelects.forEach((selectDiv) => {
    const hasValue = selectDiv.querySelector('[class*="-singleValue"]');
    let existingError = selectDiv.querySelector(".error-text");
    if (!hasValue) {
      valid = false;
      const label = selectDiv.closest("div")?.querySelector("label")?.innerText || "Select";
      emptyFields.push(label.trim());
      if (!existingError) {
        const span = document.createElement("span");
        span.textContent = "Empty";
        span.className = "error-text";
        span.style.color = "red";
        span.style.fontSize = "10px";
        span.style.paddingLeft = "4px";
        selectDiv.appendChild(span);
      }
    } else if (existingError) {
      existingError.remove();
    }
  });

  if (!valid && emptyFields.length > 0) {
    Swal.fire({
      icon: "warning",
      title: "Please fill all required fields!",
      html: `<b>Missing:</b> ${emptyFields.join(", ")}`,
    });
  }
  return valid;
};

const handleBankPrev = () => {
  if (currentStep > 1) setCurrentStep(currentStep - 1);
};

const handleBankNext = async () => {
  if (!validateBankStep(currentStep)) {
    Swal.fire("Please fill required fields!", "", "warning");
    return;
  }

  if (!allDocsUploaded) {
    Swal.fire("Please upload required documents first!", "", "warning");
    return;
  }

  try {
    $("#showLoader").removeClass("d-none").addClass("d-flex");
    const formData = new FormData($("#bankVerifyForm")[0]);
    formData.append("aid", aid);
    formData.append("lineupcandidateid", bankVerifyData.reqhidden || bankVerifyIvr);

    if (currentStep === 1) {
      formData.append("action", "step1");
      formData.append("salu", selectSalu);
      formData.append("blood", selectblood);
      formData.append("contract", selectContract);
    } else {
      formData.append("action", "step2");
      formData.append("bankName", selectBank);
    }

    const res = await axios.post(apiurl + "onboarded.php", formData);
    if (res.data.status) {
      Swal.fire({
        icon: "success",
        title: res.data.message,
        timer: 1500,
        showConfirmButton: false,
      }).then(() => {
        if (currentStep === 1) {
          setCurrentStep(currentStep + 1);
        } else {
          handleBankVerifyReset();
          $("#bankVerifyModal .btn-close").click();
          fetchData();
        }
      });
    } else {
      Swal.fire("Error", res.data.message || "Save failed", "error");
    }
  } catch (error) {
    console.error("Error verifying bank:", error.response?.data?.message || error.message);
    Swal.fire("Error", "Server connection failed!", "error");
  } finally {
    $("#showLoader").removeClass("d-flex").addClass("d-none");
  }
};

const handleFileSelect = (id, file) => {
  if (!file) return;
  const preview = URL.createObjectURL(file);
  setDocuments((prev) => ({
    ...prev,
    [id]: {
      ...prev[id],
      file,
      preview,
      name: file.name,
      type: file.type,
      uploaded: false,
    }
  }));
};

const uploadDocument = async (id) => {
  const doc = documents[id];
  if (!doc.file) {
    Swal.fire("Select file first");
    return;
  }

  $("#showLoader").removeClass("d-none").addClass("d-flex");
  try {
    const formData = new FormData();
    formData.append("document", doc.file);
    formData.append("documentype", id);
    formData.append("email", bankVerifyData.email);
    formData.append("userId", bankVerifyData.reqhidden || bankVerifyIvr);
    formData.append("action", "upload");

    const res = await axios.post(apiurl + "upload.php", formData);
    setDocuments((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        uploaded: !!res.data.status,
      }
    }));

    Swal.fire({
      icon: res.data.status ? "success" : "error",
      title: res.data.message
    });
  } catch (error) {
    console.error("Document upload error:", error);
    Swal.fire("Error", "Document upload failed", "error");
  } finally {
    $("#showLoader").removeClass("d-flex").addClass("d-none");
  }
};

const renderUploadBox = (id) => {
  const doc = documents[id];
  return (
    <div className="upload-card">
      <input
        type="file"
        accept=".jpg,.jpeg,.png,.pdf"
        ref={(el) => fileRefs.current[id] = el}
        style={{ display: "none" }}
        onChange={(e) => handleFileSelect(id, e.target.files[0])}
      />

      {doc.preview ? (
        <div className="preview-box">
          {doc.type === "application/pdf" || String(doc.preview).toLowerCase().endsWith(".pdf") ? (
            <div className="pdf-preview">
              <a target="_blank" rel="noreferrer" href={doc.preview}>View Pdf</a>
            </div>
          ) : (
            <img src={doc.preview} alt="preview" />
          )}
        </div>
      ) : (
        <div className="upload-placeholder" onClick={() => fileRefs.current[id]?.click()}>
          <span>Select File</span>
        </div>
      )}

      <div className="upload-actions">
        <button className="btn btn-success btn-sm" type="button" onClick={() => uploadDocument(id)}>
          Upload
        </button>
        <button className="btn btn-warning btn-sm" type="button" onClick={() => fileRefs.current[id]?.click()}>
          Change
        </button>
      </div>
    </div>
  );
};

const openBankVerifyModal = async (idd) => {
  $("#showLoader").removeClass("d-none").addClass("d-flex");
  try {
    const formData = new FormData();
    formData.append("lineup", idd);
    formData.append("vtype", "113");
    formData.append("aidtype", aidtype);
    const response = await axios.post(apiurl + "onboarded.php", formData);

    if (response.data.status === true) {
      const rowData = response.data.main?.[0] || {};
      setBankVerifyData(rowData);
      setBankVerifyIvr(rowData.reqhidden || "");
      setContractOptions(response.data.contracts || []);
      setCurrentStep(1);

      setDocuments({
        1: { file: null, preview: rowData.aadharfront || "", uploaded: !!rowData.aadharfront, type: rowData.aadharfront?.endsWith(".pdf") ? "application/pdf" : "image" },
        2: { file: null, preview: rowData.aadharback || "", uploaded: !!rowData.aadharback, type: rowData.aadharback?.endsWith(".pdf") ? "application/pdf" : "image" },
        3: { file: null, preview: rowData.resume || "", uploaded: !!rowData.resume, type: rowData.resume?.endsWith(".pdf") ? "application/pdf" : "image" },
        4: { file: null, preview: rowData.photo || "", uploaded: !!rowData.photo, type: rowData.photo?.endsWith(".pdf") ? "application/pdf" : "image" }
      });

      $("#bank_verify_modal_trigger").click();
    } else {
      Swal.fire({
        position: "top-center",
        icon: "error",
        title: response.data.message || "Something went wrong!",
        showConfirmButton: false,
        timer: 2000
      });
    }
  } catch (error) {
    console.error("Bank modal error:", error.response?.data?.message || error.message);
    Swal.fire("Error", "Unable to open bank verify modal", "error");
  } finally {
    $("#showLoader").removeClass("d-flex").addClass("d-none");
  }
};


const handleOnboardClick = (row) => {
  setSelectedCandidate(row); // store candidate name and id for modal
};


  const [options, setOptions] = useState({
    profile: [],
    location: [],
    interview: [],
  });

  const selects = [
    {
      key: "profile",
      label: "Select Designation",
      placeholder: "Enter POST",
    },
    {
      key: "location",
      label: "Select Location",
      placeholder: "Enter Location",
    },
    {
      key: "interview",
      label: "Select Interview",
      placeholder: "Enter Status",
    },
  ];

 const [selectedRows, setSelectedRows] = useState([]);
const [toggledClearRows, setToggleClearRows] = useState(false);
const [bulkFormData, setBulkFormData] = useState({
    interviewStatus: '',
    interviewTime: '',
    joinStatus: '',
    joinTime: '',
});

const isRowSelectable = (row) => {
    if (aidtype === '113' && row.jstatus?.toLowerCase() === 'joined') return false;
    return true;
};

const handleSelectAll = (checked) => {
    if (checked) {
        const allIds = processedData.filter(isRowSelectable).map(row => row.id);
        setSelectedRows(allIds);
    } else {
        setSelectedRows([]);
    }
};

  const handleRowSelect = (id, checked) => {
    if (checked) {
      setSelectedRows((prev) => [...prev, id]);
    } else {
      setSelectedRows((prev) => prev.filter((rowId) => rowId !== id));
    }
  };

const EditData = async (idd,val) => { 
       $("#showLoader").removeClass('d-none').addClass('d-flex');
       
       try{

        if(val!='2'){
        const formdate = new FormData();
        formdate.append("lineup",idd);
        formdate.append("vtype",val);
        const response = await axios.post(apiurl + 'line.php',formdate);
         if(response.data.status === true){
            $("#tera_modal3").click();
            setIvrData(response.data.main[0]);
            setIvr(response.data.main[0].reqhidden);
         }
         else{
                  Swal.fire({
                    position: "top-center",
                    icon: "error",
                    title: "Something Went Wrong !",
                    showConfirmButton: false,
                    timer: 2000
                  });
         }
       }
               else{
               const response = await axios.get(apiurl + 'requirement.php?edit=' + idd);
               
               if (response.data.status == true) {
                    setRequirement(response.data.data[0]);
                   $("#table_modal").click();
               } else {
                 alert("data not found");
               }
       
               }

       }
       catch (error) {
        console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
       }
       finally {
         $("#showLoader").removeClass('d-flex').addClass('d-none');
       }
};


const fetchData = async () => {
  const response = await axios.get(apiurl+'line.php?subdomain=react&lid='+aid+"&aidtype="+aidtype); // Replace with your API endpoint
   setStaff(response.data.staff || []);

   setOptions({ profile: response.data.post, location: response.data.city ,interview:[
    { value: '', label: 'All' }, 
    { value: 'pending', label: 'Pending' },
      { value: 'success', label: 'Selected' },
      { value: 'decline', label: 'Rejected' }
   ]});

   setMetaData({
  appname: response.data.client,
  edit: response.data.edit,
  del: response.data.del,
  add: response.data.add,
  view: response.data.view,
  typess:response.data.typess,
  icon:response.data.icon,
  defaultShow:response.data.defaultShow,
  checkbox:response.data.checkbox,
  recname: response.data.recname || '',
  jobtitle: response.data.jobtitle || '',
  location: response.data.location || '',
  require: response.data.require || ''
   });

 setTotal(response.data.total);
 setTableLoading(false);

};

  const filterBtn = async (sel = selected) => {
    const data = {
      location: sel.location?.value,
      profiles: sel.profile?.value,
      interview: sel.interview?.value,
      lid: aid,
      aidtype:aidtype,
      subdomain: 'react'
    };

    $("#showLoader").removeClass('d-none').addClass('d-flex');
    const response = await axios.get(apiurl + 'line.php', {
      params: data
    });

    setStaff(response.data.staff || []);
    setTotal(response.data.total);
    $("#showLoader").removeClass('d-flex').addClass('d-none');
  };

useEffect(() => {
  document.title = "Line up Candidate | MERAQUI";
    fetchData();
 
}, [aid,refreshKey]);

const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

const getComparator = (order, orderBy) => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};

const descendingComparator = (a, b, orderBy) => {
    const valA = orderBy(a);
    const valB = orderBy(b);

    if (valB < valA) {
        return -1;
    }
    if (valB > valA) {
        return 1;
    }
    return 0;
};


const ColumnHeaderWithFilter = ({ 
    column, 
    orderBySelector, 
    order, 
    handleRequestSort, 
    columnFilters, 
    setColumnFilters,
    
}) => {
   const [localOpenKey, setLocalOpenKey] = useState(null);
   const [anchorEl, setAnchorEl] = useState(null);
    const accessorKey = column.accessorKey;
   
   const isMenuOpen = localOpenKey === accessorKey; // <--- NEW WAY
    const currentFilter = String(columnFilters[accessorKey] || ''); 
    const isSorted = orderBySelector === column.selector;

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setLocalOpenKey(accessorKey);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setLocalOpenKey(null);
    };

    const handleFilterChange = (e) => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: e.target.value
        }));
    };
    
    const isSortable = !!column.selector;
    const isFilterable = !!column.filterType;


    // --- Custom Filter Input Renderer ---
    const renderFilterInput = () => {
        if (column.filterType === 'select') {
            // Use the dynamically derived filterOptions attached to the column object
            const filterOptions = column.dynamicFilterOptions || [];
            
            return (
                <MuiSelect
                    label={`Filter ${column.header}`}
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    sx={{ width: '100%' }}
                >
                    {/* Default option to show all values */}
                    <MenuItem value="">— All —</MenuItem>
                    {filterOptions.map(option => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                </MuiSelect>
            );
        }

        if (column.filterType === 'date') {
            return (
                <TextField
                    label={`Filter ${column.header}`}
                    type="date" 
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    // This ensures the label is correctly positioned for date input
                    InputLabelProps={{ shrink: true }} 
                    sx={{ width: '100%' }}
                />
            );
        }

        // Default: text filter
        return (
            <TextField
                label={`Filter ${column.header}`}
                variant="outlined"
                size="small"
                value={currentFilter}
                onChange={handleFilterChange}
                autoFocus
                sx={{ width: '100%' }}
            />
        );
    };


    return (
        <Box 
            sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between', 
                width: '100%', 
                '& .MuiTableSortLabel-root': { flexGrow: 1 } 
            }}
        >
            <TableSortLabel
                active={isSorted}
                direction={isSorted ? order : 'asc'}
                onClick={() => isSortable && handleRequestSort(column.selector)}
                IconComponent={isSorted ? (order === 'desc' ? ArrowDropDown : ArrowDropUp) : undefined}
                sx={{ 
                    cursor: isSortable ? 'pointer' : 'default',
                    justifyContent: column.headerAlign === 'center' ? 'center' : 'flex-start',
                    '&.Mui-active': {
                        color: 'primary.main',
                        fontWeight: 'bold',
                    }
                }}
            >
                {column.header}
            </TableSortLabel>

            {isFilterable && (
                <>
                    <IconButton
                        aria-label="filter"
                        size="small"
                        onClick={handleClick}
                        sx={{ 
                            ml: 1, 
                            p: 0,
                            color: currentFilter ? 'primary.main' : 'text.secondary',
                        }}
                    >
                        <MoreVertIcon fontSize="inherit" />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={isMenuOpen}
                        onClose={handleClose}
                        onClick={(e) => e.stopPropagation()} 
                        PaperProps={{
                            sx: { width: 250, p: 1, boxShadow: 6, borderRadius: 2 }
                        }}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >
                        <Box sx={{ width: '100%', p: 1 }}>
                            {renderFilterInput()}
                        </Box>
                        
                        {/* Clear filter button */}
                        {currentFilter && (
                             <Button
                                onClick={() => {
                                    setColumnFilters(prev => ({ ...prev, [accessorKey]: '' }));
                                    handleClose();
                                }}
                                size="small"
                                color="error"
                                sx={{ mt: 1, textTransform: 'none' }}
                            >
                                Clear Filter
                            </Button>
                        )}
                    </Menu>
                </>
            )}
        </Box>
    );
};

const BASE_COLUMNS_DEFINITION = [
    // We can skip the 'select' column here, as it doesn't participate in filtering/sorting
    { accessorKey: 'rid', selector: (row) => row.requireid, filterType: 'text' },
    { accessorKey: 'campid', selector: (row) => row.campid, filterType: 'text' },
    { accessorKey: 'name', selector: (row) => row.name, filterType: 'text' },
    { accessorKey: 'mobile', selector: (row) => row.mobile, filterType: 'text' },
    { accessorKey: 'designation', selector: (row) => row.profile, filterType: 'select' },
    { accessorKey: 'location', selector: (row) => row.location, filterType: 'select' },
    { accessorKey: 'education', selector: (row) => JSON.stringify(row.qual), filterType: 'text' },
    { accessorKey: 'exp', selector: (row) => row.exp, filterType: 'select' },
    // Only include columns that *do* have sorting/filtering logic in processedData
    // 'istatus', 'jstatus', 'action' columns rely on custom Cells, so they can be defined later.
];

    const processedData = useMemo(() => {
        const columnsToUse = BASE_COLUMNS_DEFINITION;
        let filtered = staff;
        const lowerCaseFilter = globalFilterText.toLowerCase();

        // 1. Apply Global Filter
        if (lowerCaseFilter) {
            filtered = filtered.filter(row => 
                columnsToUse.some(column => {
                    const value = column.selector ? String(column.selector(row)) : '';
                    return value.toLowerCase().includes(lowerCaseFilter);
                })
            );
        }

        // 2. Apply Column Filters
        filtered = filtered.filter(row => {
            return columnsToUse.every(column => {
                const accessorKey = column.accessorKey;
                const filterValue = columnFilters[accessorKey];

                if (!filterValue) return true;
                if (!column.selector) return true;

                const rowValue = String(column.selector(row));

                switch (column.filterType) {
                    case 'select':
                        // Must match the selected value exactly
                        return rowValue === filterValue; 
                        
                    case 'date':
                        // Check if the date string (e.g., '2024-01-15') includes the filter date
                        return rowValue.includes(filterValue); 
                        
                    case 'text':
                    default:
                        return rowValue.toLowerCase().includes(filterValue.toLowerCase());
                }
            });
        });

        // 3. Sorting Logic
        const sortColumn = columnsToUse.find(col => col.selector === orderBySelector);

        if (sortColumn) {
            return stableSort(filtered, getComparator(order, sortColumn.selector));
        }
        
        return filtered;

    }, [staff, BASE_COLUMNS_DEFINITION, order, orderBySelector, globalFilterText, columnFilters]);

const selectableRows = processedData.filter(isRowSelectable);
const isAllSelected = selectableRows.length > 0 && selectableRows.every(row => selectedRows.includes(row.id));
const isIndeterminate = selectedRows.length > 0 && !isAllSelected;

const columns = useMemo(() => {
        let baseColumns = [
         { 
        accessorKey: 'select', 
        size: 10, 
        header: (
            <Checkbox
                color="primary"
                indeterminate={isIndeterminate}
                checked={isAllSelected}
                onChange={(e) => handleSelectAll(e.target.checked)}
            />
        ),
        Cell: ({ row: { original: row } }) => {
            const disabled = !isRowSelectable(row);
            return (
                <Checkbox
                    color="primary"
                    checked={selectedRows.includes(row.id)}
                    disabled={disabled}
                    onChange={(e) => {
                        e.stopPropagation();
                        handleRowSelect(row.id, e.target.checked);
                    }}
                />
            );
        }
    },
            { accessorKey: 'rid', header: 'Req. ID', size: 150, selector: (row) => row.requireid, filterType: 'text', headerAlign: 'center' },
            { accessorKey: 'lineup_source', header: 'Source', size: 150, selector: (row) => row.lineup_source || row.campid, filterType: 'text' },
            { 
                accessorKey: 'name', 
                header: 'Name', 
                size: 150, 
                selector: (row) => row.name, 
                filterType: 'text'
            },
            { 
                accessorKey: 'mobile', 
                header: 'Mobile Number', 
                size: 150, 
                selector: (row) => row.mobile, 
                filterType: 'text'
            },
            { 
                accessorKey: 'designation', 
                header: 'Designation', 
                size: 150, 
                selector: (row) => row.profile, 
                filterType: 'select',
                dynamicFilterOptions: dynamicFilterOptions['designation']

            },
            { 
                accessorKey: 'location', 
                header: 'Location', 
                size: 150, 
                selector: (row) => row.location, 
                filterType: 'select',
                dynamicFilterOptions: dynamicFilterOptions['location']
            },
            { 
                accessorKey: 'education', 
                header: 'Qualification', 
                size: 150, 
                selector: (row) => JSON.stringify(row.qual), 
                filterType: 'text'
            },{ 
                accessorKey: 'exp', 
                header: 'Experience', 
                size: 150, 
                selector: (row) => row.exp, 
                filterType: 'select',
                dynamicFilterOptions: dynamicFilterOptions['exp']
            },
             {
            accessorKey: 'istatus',
            header: 'Interview Status',
            minWidth: "160px",
            wrap: true,
            Cell: ({ row: { original: row } }) => {
                return    <div style={{ lineHeight: '1.3em' }}> {row.istatus || '-'} <br /> <b>{row.istatustime || '-'}</b>  </div>;
            },
            filterType: 'select',
                dynamicFilterOptions: dynamicFilterOptions['istatus']
        },
        ...(aidtype !== '112' ? [{
            accessorKey: 'jstatus',
            header: 'Joined Status',
            minWidth: "160px",
            wrap: true,
            Cell: ({ row: { original: row } }) => {
                return <div style={{ lineHeight: '1.3em' }}> {row.jstatus || '-'} <br /> <b>{row.jstatustime || '-'}</b> </div>;
            },
            filterType: 'select',
            dynamicFilterOptions: dynamicFilterOptions['jstatus']
        }] : []),

        ...(aidtype !== '112' ? [{
            accessorKey: 'action',
            header: 'Action',
            minWidth: "180px",
            wrap: true,
            Cell: ({ row: { original: row } }) => {
                const istatus = row.istatus ? row.istatus.toLowerCase() : '';
                const jstatus = row.jstatus ? row.jstatus.toLowerCase() : '';
                if (istatus === 'selected' && jstatus === 'joined') {
                    if (row.bstatus === 'success') {
                        return <span className='btn btn-sm btn-success'>Onboarded</span>;
                    }
                    return (
                        <button
                            className="btn btn-sm btn-secondary"
                            data-bs-toggle="modal"
                            data-bs-target="#onboardConfirmModal"
                            onClick={() => handleOnboardClick(row)}
                        >
                            Initiate Onboarding
                        </button>
                    );
                }
                return (
                    <button
                        className="btn btn-sm btn-primary"
                        onClick={() => EditData(row.id, aidtype)}
                    >
                        Update
                    </button>
                );
            },
            filterType: 'select',
            dynamicFilterOptions: dynamicFilterOptions['istatus']
        }] : []),


        ];

      return baseColumns;
   }, [dynamicFilterOptions, shouldIncludeActionColumn, metaData.bd, selectedRows, handleRowSelect, handleSelectAll, isAllSelected, isIndeterminate, openBankVerifyModal]);

    const handleRequestSort = useCallback((selector) => {
        const isAsc = orderBySelector === selector && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBySelector(() => selector);
    }, [order, orderBySelector]);


const RenderReqIdCell = useCallback(({ row }) => {
    const rowData = row;
     const isViewDetailClickable = true; // Set to true or use metaData.view check if needed
    
    let statsColor = '#10B981'; let idTooltipContent = 'Requirement In-process';
    if (rowData.rstatus.toLowerCase() === 'onhold') {
        statsColor = '#F59E0B'; idTooltipContent='Requirement Onhold';
    } else if (rowData.rstatus.toLowerCase() === 'closed') {
        statsColor = '#9CA3AF'; idTooltipContent='Requirement Closed';
    }
 return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' ,width:150}}>

           <Tooltip title={isViewDetailClickable ? 'View Detail' : ''} arrow>
                <IconButton
                    size="small"
                    onClick={() => EditData(rowData.reqidhidden,"2")} 
                    sx={{
                        color: 'orange', 
                        p: 0.5,
                        '&:hover': {
                            color: isViewDetailClickable ? '#0056b3' : 'text.disabled',
                            backgroundColor: 'transparent'
                        }
                    }}
                >
                    <VisibilityOutlined sx={{ fontSize: '1rem' }} />
                </IconButton>
            </Tooltip>
            
             <Tooltip title={idTooltipContent} arrow>
                <Button
                    sx={{
                        background: "none",
                        border: "none",
                        color: statsColor, // Use status color for the ID text
                         padding: 0,
                        minWidth: 0, 
                        fontWeight: 500,
                        textAlign: 'left',
                        textTransform: 'none',
                        fontSize: '0.875rem',
                        '&:hover': { backgroundColor: 'transparent' }
                    }}
                >
                    {rowData.requireid}
                </Button>
            </Tooltip>
            
        </Box>
    );
}, [EditData]);

const confirmOnboard = async () => {
  if (!selectedCandidate) return;

  $("#showLoader").removeClass('d-none').addClass('d-flex');

  try {
    const formData = new FormData();
    formData.append("action", "onboardCandidate");
    formData.append("id", selectedCandidate.id);
    formData.append("aidtype", aidtype);
    formData.append("subdomain", "react");

    const response = await axios.post(apiurl + "line.php", formData);

    if (response.data.status === true) {
      Swal.fire({
        position: "top-center",
        icon: "success",
        title: response.data.message,
        showConfirmButton: false,
        timer: 2000
      }).then(() => {
        fetchData();
      });
    } else {
      Swal.fire({
        position: "top-center",
        icon: "error",
        title: response.data.message,
        showConfirmButton: false,
        timer: 2000
      });
    }
  } catch (error) {
    console.error("Error onboarding:", error.response?.data?.message || error.message);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.response?.data?.message || "Something went wrong!",
    });
  } finally {
    $("#showLoader").removeClass('d-flex').addClass('d-none');
    $("#onboardConfirmModal .text-danger").click();
  }
};

   // ✅ Loader while checking session
  if (newloading) {
    
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/90 z-50">
        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }


const IvrFORM = async (e) =>{
       e.preventDefault();
       $("#showLoader").removeClass('d-none').addClass('d-flex');
       try {
       const formData = new FormData($("#submitform")[0]);
        formData.append("interviewStatus", ivrdata.istatus || '');
        formData.append("joinStatus", ivrdata.jstatus || '');
        formData.append("gender", ivrdata.gender || '');
        formData.append("source", ivrdata.source || '');
        formData.append("napsStaffing", ivrdata.naps || '');
        formData.append("documentStatus", ivrdata.dstatus || '');
        formData.append("aid",aid);
        formData.append("lineupcandidateid",ivr);
       const response = await axios.post(apiurl + "line.php", formData);
     
      if (response.data.status === true) {
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          $(".offcanvas .btn-close").click();
          fetchData();
        });
      }
      else {
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
    } catch (error) {
      console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
    }
    finally {
       $("#showLoader").removeClass('d-flex').addClass('d-none');
    }
};

const handleSelectChange = (fieldName, option) => {
    setIvrData(prevData => ({
        ...prevData,
        [fieldName]: option ? option.value : null,
    }));
};


    const handleModalBulkUpdate = async () => {
    const { interviewStatus, interviewTime, joinStatus, joinTime } = bulkFormData;

    if (selectedRows.length === 0 || (!interviewStatus && !joinStatus)) return;

  
    $("#showLoader").removeClass('d-none').addClass('d-flex');
    try {
        
        const formdata= new FormData();
  formdata.append("interviewStatus", interviewStatus);
formdata.append("interviewTime", (interviewStatus === 'success' && interviewTime) ? interviewTime : ''); // Must be string, not null
formdata.append("joinStatus", joinStatus);
formdata.append("joinTime", (joinStatus === 'success' && joinTime) ? joinTime : ''); // Must be string, not null
    formdata.append("ids[]", selectedRows); // Use [] for PHP to recognize it as an array

const response = await axios.post(apiurl + 'line.php', formdata); 

        if (response.data.status === true) {
            Swal.fire({ position: "top-center", icon: "success", title: response.data.message, showConfirmButton: false, timer: 2000 })
                .then(() => {
                    setToggleClearRows(prev => !prev);
                    setSelectedRows([]);
                    setBulkFormData({ interviewStatus: '', interviewTime: '', joinStatus: '', joinTime: '' });
                    $("#exampleModalFullscreen .text-danger").click();
                    fetchData();
                });
        } else {
            Swal.fire({ position: "top-center", icon: "error", title: response.data.message, showConfirmButton: false, timer: 2000 });
        }
    } catch (error) {
        console.error("BulkUpdate Error:", error);
    } finally {
        $("#showLoader").removeClass('d-flex').addClass('d-none');
    }
};

const handleModalChange = (field, value) => {
    setBulkFormData(prev => ({
        ...prev,
        [field]: value,
    }));
};


return(
<>

<div
  className="modal fade effect-sign"
  id="onboardConfirmModal"
  tabIndex="-1"
  aria-labelledby="onboardConfirmModalLabel"
  aria-hidden="true"
>
  <div className="modal-dialog modal-md modal-dialog-centered">
    <div className="modal-content">
      <div
        className="modal-header"
        style={{ paddingTop: "10px", paddingBottom: "10px" }}
      >
        <span className="fs-18 text-dark fw-semibold mb-0">
          Confirm Onboarding
        </span>
        <button
          type="button"
          className="btn fs-18 text-danger"
          style={{ padding: "0px" }}
          data-bs-dismiss="modal"
        >
          X
        </button>
      </div>

      <div className="modal-body text-center">
        {selectedCandidate ? (
          <p className='fs-19'>
            Are you sure you want to onboard{" "}
            <b>{selectedCandidate.name}</b> candidate?
          </p>
        ) : (
          <p>Loading candidate...</p>
        )}

        <div className="d-flex justify-content-center mt-3 gap-2">
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={confirmOnboard}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<div className="modal fade effect-sign" id="exampleModalFullscreen" tabIndex="-1" aria-labelledby="exampleModalFullscreenLabel" aria-hidden="true">
    <div className="modal-dialog modal-md"> {/* Changed to modal-md for more space */}
        <div className="modal-content">
            <div className="modal-header" style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                <span className="fs-18 text-dark fw-semibold mb-0">Bulk Status Update</span>
                <button type="button" className="btn fs-18 text-danger" style={{ padding: '0px' }} data-bs-dismiss="modal">X</button>
            </div>
            
            <div className="modal-body">
                <form onSubmit={(e) => { e.preventDefault(); handleModalBulkUpdate(); }}>
                    <div className='row g-3'>

                        {/* Interview fields — only for aidtype=112 */}
                        {aidtype === '112' && <>
                        <div className="col-6">
                            <label className="form-label">Interview Status</label>
                            <Select
                                options={interviewStatusOptions}
                                value={interviewStatusOptions.find(opt => opt.value === bulkFormData.interviewStatus) || null}
                                onChange={(option) => handleModalChange('interviewStatus', option ? option.value : '')}
                                placeholder="Select Status"
                            />
                        </div>
                        <div className="col-6">
                            <label className="form-label">Interview Selected Time</label>
                            <input
                                type="datetime-local"
                                className="form-control"
                                value={bulkFormData.interviewTime}
                                onChange={(e) => handleModalChange('interviewTime', e.target.value)}
                                disabled={bulkFormData.interviewStatus !== 'success'}
                            />
                        </div>
                        </>}

                        {/* Join fields — only for aidtype=113 */}
                        {aidtype === '113' && <>
                        <div className="col-6">
                            <label className="form-label">Join Status</label>
                            <Select
                                options={joinStatusOptions}
                                value={joinStatusOptions.find(opt => opt.value === bulkFormData.joinStatus) || null}
                                onChange={(option) => handleModalChange('joinStatus', option ? option.value : '')}
                                placeholder="Select Status"
                            />
                        </div>
                        <div className="col-6">
                            <label className="form-label">Joining Time</label>
                            <input
                                type="datetime-local"
                                className="form-control"
                                value={bulkFormData.joinTime}
                                onChange={(e) => handleModalChange('joinTime', e.target.value)}
                                disabled={bulkFormData.joinStatus !== 'success'}
                            />
                        </div>
                        </>}

                    </div>

                    <div className="d-flex justify-content-end mt-4">
                        <button type="submit" className="btn btn-success" disabled={aidtype === '112' ? !bulkFormData.interviewStatus : !bulkFormData.joinStatus}>
                            Apply Bulk Update to {selectedRows.length} Rows
                        </button>
                    </div>
                </form>
            </div>
</div>
</div>
</div>
<button data-bs-toggle="offcanvas" id="tera_modal3" data-bs-target="#exampleModal" type="button" style={{ display: 'none' }}></button>
<button data-bs-toggle="offcanvas" id="bank_verify_modal_trigger" data-bs-target="#bankVerifyModal" type="button" style={{ display: 'none' }}></button>

<div className="offcanvas offcanvas-top" style={{ maxHeight: '100%', height: 'auto', backgroundColor: 'rgb(245 245 245)' }} tabIndex="-1" id="bankVerifyModal" data-bs-keyboard="false">
  <div className="offcanvas-header border-bottom border-block-end-dashed">
    <h5 className="offcanvas-title">Bank Verification - {bankVerifyData.name || "-"}</h5>
    <button
      type="button"
      className="btn-close"
      data-bs-dismiss="offcanvas"
      onClick={handleBankVerifyReset}
      aria-label="Close"
    ></button>
  </div>

  <div className="offcanvas-body" style={{ paddingBottom: "80px" }}>
    <form id="bankVerifyForm" key={bankVerifyData.id || bankVerifyData.reqhidden || "bank-verify-form"} encType="multipart/form-data">
      <div className={`form-step ${currentStep === 1 ? "active" : ""}`} data-step="1">
        <div className="row g-3">
          <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
            <label htmlFor="campid_bank" className="form-label">Campaign Id</label>
            <input id="campid_bank" defaultValue={bankVerifyData.campid || ""} type="text" className="form-control" readOnly disabled />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
            <label htmlFor="requireid_bank" className="form-label">Requirement Id</label>
            <input id="requireid_bank" defaultValue={bankVerifyData.requireid || ""} name="requireid" type="text" className="form-control" readOnly disabled />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
            <label htmlFor="client_bank" className="form-label">Client Name</label>
            <input id="client_bank" defaultValue={bankVerifyData.client || ""} type="text" className="form-control" readOnly disabled />
          </div>
          <div className="col-2 mb-3">
            <label className="form-label">Requirement Details</label>
            <button
              className="btn btn-link"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#moreInfoCollapseBank"
              aria-expanded="false"
              aria-controls="moreInfoCollapseBank"
              style={{ textDecoration: "none" }}
            >
              <span className="me-2">More Details...</span>
              <i className="bi bi-chevron-down"></i>
            </button>
          </div>
        </div>

        <div className="collapse" id="moreInfoCollapseBank" style={{ border: "2px solid rgb(215 226 255)", padding: "10px", marginBottom: "11px", borderRadius: "10px" }}>
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="jobTitle_bank" className="form-label">Requirement Name/Job Title</label>
              <input id="jobTitle_bank" defaultValue={bankVerifyData.jobTitle || ""} type="text" className="form-control" readOnly disabled />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="location_bank" className="form-label">Requirement Location</label>
              <input id="location_bank" defaultValue={bankVerifyData.location || ""} type="text" className="form-control" readOnly disabled />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="recName_bank" className="form-label">Rec Name</label>
              <input id="recName_bank" defaultValue={bankVerifyData.recname || ""} type="text" className="form-control" readOnly disabled />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="costCenter_bank" className="form-label">Cost Center</label>
              <input id="costCenter_bank" defaultValue={bankVerifyData.costCenter || ""} type="text" className="form-control" readOnly disabled />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="rname_bank" className="form-label">Recruiter Name</label>
              <input id="rname_bank" defaultValue={bankVerifyData.rname || ""} type="text" className="form-control" readOnly disabled />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="remail_bank" className="form-label">Recruiter Email</label>
              <input id="remail_bank" defaultValue={bankVerifyData.remail || ""} type="text" className="form-control" readOnly disabled />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="spoc_bank" className="form-label">SPOC Person ID</label>
              <input id="spoc_bank" defaultValue={bankVerifyData.spoc || ""} type="text" className="form-control" readOnly disabled />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="ldate_bank" className="form-label">Line Request Date</label>
              <input id="ldate_bank" defaultValue={bankVerifyData.ldate || ""} type="text" className="form-control" readOnly disabled />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="idate_bank" className="form-label">Interview Date</label>
              <input id="idate_bank" defaultValue={bankVerifyData.idate || ""} type="text" className="form-control" readOnly disabled />
            </div>
          </div>
        </div>

        <div className="row mb-3 mt-1">
          <div className="col-md-3 mb-3">
            <label className="form-label"><span className="text-danger">*</span> Aadhar Front</label>
            {renderUploadBox(1)}
          </div>
          <div className="col-md-3 mb-3">
            <label className="form-label"><span className="text-danger">*</span> Aadhar Back</label>
            {renderUploadBox(2)}
          </div>
          <div className="col-md-3 mb-3">
            <label className="form-label">Resume (Optional)</label>
            {renderUploadBox(3)}
          </div>
          <div className="col-md-3 mb-3">
            <label className="form-label">Passport Photo (Optional)</label>
            {renderUploadBox(4)}
          </div>
        </div>

        <div className="row g-3">
          <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
            <label htmlFor="candidate_name_bank" className="form-label">Candidate Name</label>
            <input id="candidate_name_bank" defaultValue={bankVerifyData.name || ""} type="text" className="form-control" readOnly disabled />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
            <label htmlFor="candidate_mobile_bank" className="form-label">Candidate Mobile</label>
            <input id="candidate_mobile_bank" defaultValue={bankVerifyData.mobile || ""} type="text" className="form-control" readOnly disabled />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
            <label htmlFor="candidate_profile_bank" className="form-label">Candidate Designation</label>
            <input id="candidate_profile_bank" defaultValue={bankVerifyData.profile || ""} type="text" className="form-control" />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
            <label htmlFor="candidate_city_bank" className="form-label">Candidate Location</label>
            <input id="candidate_city_bank" defaultValue={bankVerifyData.city || ""} type="text" className="form-control" />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
            <label htmlFor="candidate_qual_bank" className="form-label">Candidate Qualification</label>
            <input id="candidate_qual_bank" defaultValue={JSON.stringify(bankVerifyData.qual || "")} type="text" className="form-control" />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
            <label htmlFor="candidate_exp_bank" className="form-label">Candidate Experience</label>
            <input id="candidate_exp_bank" defaultValue={bankVerifyData.exp || ""} type="text" className="form-control" />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6">
            <label htmlFor="dob_bank" className="form-label">DOB</label>
            <input id="dob_bank" defaultValue={bankVerifyData.dob || ""} name="age" type="date" className="form-control" />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6">
            <label htmlFor="age_bank" className="form-label">Age</label>
            <input id="age_bank" defaultValue={bankVerifyData.age || ""} name="age" type="text" className="form-control" />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6">
            <label htmlFor="state_bank" className="form-label">State</label>
            <input id="state_bank" name="state" type="text" className="form-control" defaultValue={bankVerifyData.state || ""} />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6">
            <label htmlFor="district_bank" className="form-label">District</label>
            <input id="district_bank" defaultValue={bankVerifyData.city || ""} name="city" type="text" className="form-control" />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6">
            <label htmlFor="pincode_bank" className="form-label">Pincode</label>
            <input id="pincode_bank" defaultValue={bankVerifyData.pincode || ""} name="pincode" type="text" className="form-control" />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <label htmlFor="address_bank" className="form-label">Address</label>
            <input id="address_bank" name="address" className="form-control" required defaultValue={bankVerifyData.address || ""} />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6">
            <label htmlFor="aadhar_bank" className="form-label"><span className="text-danger">*</span>Aadhar Number</label>
            <input id="aadhar_bank" name="aadhar" type="text" defaultValue={bankVerifyData.aadhar || ""} maxLength="12" className="form-control" required />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6">
            <label htmlFor="uan_bank" className="form-label">UAN Number</label>
            <input id="uan_bank" name="uan" type="text" defaultValue={bankVerifyData.uan || ""} maxLength="12" className="form-control" />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6">
            <label htmlFor="working_bank" className="form-label"><span className="text-danger">*</span>Working City</label>
            <input id="working_bank" name="working" defaultValue={bankVerifyData.working || ""} type="text" className="form-control" required />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6">
            <label htmlFor="edate_bank" className="form-label"><span className="text-danger">*</span>Expected Date of Joining</label>
            <input id="edate_bank" name="edate" defaultValue={bankVerifyData.edate || ""} type="date" className="form-control" required />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6">
            <label htmlFor="salu_bank" className="form-label"><span className="text-danger">*</span>Salutation</label>
            <div className="react-select-required">
              <Select
                options={saluationType}
                value={saluationType.find((opt) => opt.value === selectSalu) || null}
                onChange={(option) => setSalutation(option ? option.value : null)}
                placeholder="Select Salutation"
              />
            </div>
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6">
            <label htmlFor="blood_bank" className="form-label"><span className="text-danger">*</span>Blood Group</label>
            <div className="react-select-required">
              <Select
                options={bloodGroupType}
                value={bloodGroupType.find((opt) => opt.value === selectblood) || null}
                onChange={(option) => setBlood(option ? option.value : null)}
                placeholder="Select Blood Group"
              />
            </div>
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6">
            <label htmlFor="contract_bank" className="form-label"><span className="text-danger">*</span>Select Contract</label>
            <div className="react-select-required">
              <Select
                options={contracts}
                value={(contracts || []).find((opt) => opt.value === selectContract) || null}
                onChange={(option) => {
                  setContract(option ? option.value : null);
                  setContractEndDate(option ? option.end_date : "");
                }}
                placeholder="Select Contract"
              />
            </div>
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6">
            <label htmlFor="cdate_bank" className="form-label"><span className="text-danger">*</span>Contract End Date</label>
            <input id="cdate_bank" name="cdate" type="text" className="form-control" value={contractEndDate} disabled={selectContract == null} required />
          </div>
        </div>
      </div>

      <div className={`form-step ${currentStep === 2 ? "active" : ""}`} data-step="2">
        <div className="row g-3">
          <div className="col-6 mb-2">
            <label htmlFor="bank_mobile" className="form-label">Candidate Mobile</label>
            <input
              id="bank_mobile"
              defaultValue={bankVerifyData.bankmobile ? bankVerifyData.bankmobile : (bankVerifyData.mobile || "")}
              name="bankmodile"
              type="text"
              className="form-control"
              readOnly={!isEditable}
            />
            <div className="form-check">
              <input
                ref={inputRef}
                className="form-check-input"
                type="checkbox"
                id="editMobileCheckBank"
                checked={isEditable}
                onChange={() => setIsEditable(!isEditable)}
              />
              <label className="form-check-label" htmlFor="editMobileCheckBank">
                Want to Change Mobile Number ?
              </label>
            </div>
          </div>
          <div className="col-6">
            <label htmlFor="account_bank" className="form-label">Account Number</label>
            <input id="account_bank" name="account" type="text" className="form-control" defaultValue={bankVerifyData.bankaccount || ""} required />
          </div>
          <div className="col-6">
            <label htmlFor="bank_select" className="form-label"><span className="text-danger">*</span>Select Bank</label>
            <div className="react-select-required">
              <Select
                options={BankOptions}
                value={BankOptions.find((opt) => opt.value === selectBank) || null}
                onChange={(option) => setBank(option ? option.value : null)}
                placeholder="Select Bank"
              />
            </div>
          </div>
          <div className="col-6">
            <label htmlFor="ifsc_bank" className="form-label">IFSC Code</label>
            <input id="ifsc_bank" name="bankifsc" type="text" className="form-control" defaultValue={bankVerifyData.bankifsc || ""} required />
          </div>
        </div>
      </div>
    </form>

    <div className="wizard-footer mt-3">
      {currentStep > 1 && (
        <button type="button" onClick={handleBankPrev} className="btn btn-secondary me-2">
          Back
        </button>
      )}
      {currentStep < totalSteps && (
        <button type="button" onClick={handleBankNext} className="btn btn-primary">
          Next
        </button>
      )}
      {currentStep === totalSteps && (
        <button type="button" onClick={handleBankNext} className="btn btn-success">
          Verify Bank Details
        </button>
      )}
    </div>
  </div>
</div>

<div className="offcanvas offcanvas-top" style={{ maxHeight: '100%', height: 'auto', backgroundColor: 'rgb(245 245 245)' }} tabIndex="-1" id="exampleModal" >
    <div className="offcanvas-header border-bottom border-block-end-dashed">
      <h5 className="offcanvas-title" id="offcanvasRightLabel1">Line Up :- {ivrdata.name}</h5>
      <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="modalclose" aria-label="Close"></button>
    </div>
    <div className="offcanvas-body" style={{ paddingBottom: '80px' }}>
      <div className='d-flex'>

<form id="submitform" onSubmit={IvrFORM} encType="multipart/form-data" className='order-2'>

<div className="row g-3">
            
<div className='col-7'>
          
          <div className='row'>
            {/* --- Existing Disabled Fields (based on your list) --- */}
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="campid" className="form-label">Campaign Id</label>
              <input defaultValue={ivrdata.campid || ""} type="text" className="form-control" placeholder="Campaign ID" readOnly disabled/>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="requireid" className="form-label">Requirement Id</label>
              <input defaultValue={ivrdata.requireid || ""} name='requireid' type="text" className="form-control" placeholder="Require ID" readOnly disabled/>
            </div>
             {/* Assuming Requirement Name maps to jobTitle or similar in context - keeping jobTitle for now */}
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="jobTitle" className="form-label">Requirement Name/Job Title</label>
              <input defaultValue={ivrdata.jobTitle || ""} type="text" className="form-control" placeholder="JOB TITLE" readOnly disabled/>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="client" className="form-label">Client Name</label>
              <input defaultValue={ivrdata.client || ""} type="text" className="form-control" placeholder="Client name" readOnly disabled/>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="jobTitle" className="form-label">Requirement Location</label>
              <input defaultValue={ivrdata.location || ""} type="text" className="form-control" placeholder="Location" readOnly disabled/>
            </div>
             {/* Adding placeholders for other disabled fields from your list. You might need to adjust the 'value' props based on your 'ivrdata' structure. */}
            
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="recName" className="form-label">Rec Name</label>
              <input defaultValue={ivrdata.recname || ""} type="text" className="form-control" placeholder="Rec Name" readOnly disabled/>
            </div>
          
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="candidateName" className="form-label">Candidate Name</label>
              <input defaultValue={ivrdata.name || ""} type="text" className="form-control" placeholder="Candidate Name" readOnly disabled/>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="candidateMobile" className="form-label">Candidate Mobile</label>
              <input defaultValue={ivrdata.mobile || ""} type="text" className="form-control" placeholder="Candidate Mobile" readOnly disabled/>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="candidateDesignation" className="form-label">Candidate Designation</label>
              <input defaultValue={ivrdata.profile || ""} type="text" className="form-control" placeholder="Candidate Designation" readOnly disabled/>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="candidateCity" className="form-label">Candidate Location</label>
              <input defaultValue={ivrdata.city || ""} type="text" className="form-control" placeholder="Candidate City" readOnly disabled/>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="candidateQualification" className="form-label">Candidate Qualification</label>
              <input defaultValue={ivrdata.qual || ""} type="text" className="form-control" placeholder="Candidate Qualification" readOnly disabled/>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="candidateExperience" className="form-label">Candidate Experience</label>
              <input defaultValue={ivrdata.exp || ""} type="text" className="form-control" placeholder="Experience" readOnly disabled />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="spocPersonId" className="form-label">SPOC Person ID</label>
              <input defaultValue={ivrdata.spoc || ""} type="text" className="form-control" placeholder="SPOC Person ID" readOnly disabled/>
            </div>
              <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="lineRequestDate" className="form-label">Line Request Date</label>
              <input defaultValue={ivrdata.ldate || ""} type="text" className="form-control" placeholder="Line Request Date" readOnly disabled/>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="interviewDate" className="form-label">Interview Date</label>
              <input defaultValue={ivrdata.idate || ""} type="text" className="form-control" placeholder="Interview Date" readOnly disabled/>
            </div>
          </div>
</div>
<div className='col-5'>
  <img className="order-1" src={process.env.PUBLIC_URL + "/images/media/wait.avif"} style={{ width: '100%'}} />
</div>
  
</div>
          
<div className='row'>
    {/* 1. Interview Status */}
    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="interviewStatus" className="form-label">Interview Status</label>
        <Select
            id="interviewStatus"
            name="interviewStatus"
            options={interviewStatusOptions}
            // Find the option object that matches the current ivrdata.istatus value
            value={interviewStatusOptions.find(opt => opt.value === ivrdata.istatus) || null}
            // Use the handler to update the state field 'istatus'
            onChange={(option) => handleSelectChange('istatus', option)}
            placeholder="Select Status"
        />
    </div>

    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="stime" className="form-label">Selected Time</label>
        <input id="stime" name="stime" type="datetime-local" className="form-control" defaultValue={ivrdata.istatustime || ""}/>
    </div>

    {/* 2. Join Status */}
    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="joinStatus" className="form-label">Join Status</label>
        <Select
            id="joinStatus"
            name="joinStatus"
            options={joinStatusOptions}
            value={joinStatusOptions.find(opt => opt.value === ivrdata.jstatus) || null}
            onChange={(option) => handleSelectChange('jstatus', option)}
            placeholder="Select Status"
        />
    </div>

    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="jtime" className="form-label">Joining Time</label>
        <input id="jtime" name="jtime" type="datetime-local" className="form-control" defaultValue={ivrdata.jstatustime|| ""}/>
    </div>

    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="dateOfJoining" className="form-label">Date of Joining</label>
        <input id="dateOfJoining" name="dateOfJoining" type="date" className="form-control" defaultValue={ivrdata.djoin|| ""} />
    </div>

    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="region" className="form-label">Region</label>
        <input id="region" name="region" type="text" className="form-control" placeholder="Region" defaultValue={ivrdata.region|| ""}/>
    </div>

    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="month" className="form-label">Month</label>
        <input id="month" name="month" type="text" className="form-control" placeholder="Month" defaultValue={ivrdata.month|| ""}/>
    </div>

    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="employeeId" className="form-label">Employee ID</label>
        <input id="employeeId" name="employeeId" type="text" className="form-control" placeholder="Employee ID" defaultValue={ivrdata.empid|| ""}/>
    </div>

    {/* 3. Gender */}
    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="gender" className="form-label">Gender</label>
        <Select
            id="gender"
            name="gender"
            options={genderOptions}
            value={genderOptions.find(opt => opt.value === ivrdata.gender) || null}
            onChange={(option) => handleSelectChange('gender', option)}
            placeholder="Select Gender"
        />
    </div>

    {/* 4. Source */}
    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="source" className="form-label">Source</label>
        <Select
            id="source"
            name="source"
            options={sourceOptions}
            value={sourceOptions.find(opt => opt.value === ivrdata.source) || null}
            onChange={(option) => handleSelectChange('source', option)}
            placeholder="Select Source"
        />
    </div>

    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="monthlyNth" className="form-label">Monthly NTH</label>
        <input id="monthlyNth" name="monthlyNth" type="text" className="form-control" placeholder="Monthly NTH" defaultValue={ivrdata.nth|| ""} />
    </div>

    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="monthlyCtc" className="form-label">Monthly CTC</label>
        <input id="monthlyCtc" name="monthlyCtc" type="text" className="form-control" placeholder="Monthly CTC" defaultValue={ivrdata.ctc|| ""}/>
    </div>

    {/* 5. NAPS/Staffing */}
    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="napsStaffing" className="form-label">NAPS/Staffing</label>
        <Select
            id="napsStaffing"
            name="napsStaffing"
            options={napsStaffingOptions}
            value={napsStaffingOptions.find(opt => opt.value === ivrdata.naps) || null}
            onChange={(option) => handleSelectChange('naps', option)}
            placeholder="Select Type"
        />
    </div>

    {/* 6. Document Status */}
    <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
        <label htmlFor="documentStatus" className="form-label">Document Status</label>
        <Select
            id="documentStatus"
            name="documentStatus"
            options={documentStatusOptions}
            value={documentStatusOptions.find(opt => opt.value === ivrdata.dstatus) || null}
            onChange={(option) => handleSelectChange('dstatus', option)}
            placeholder="Select Status"
        />
    </div>

    <div className="col-3">
        <label htmlFor="remark" className="form-label">Remark</label>
        <textarea id="remark" name="remark" className="form-control" rows="3" placeholder="Add remarks" defaultValue={ivrdata.remark}></textarea>
    </div>

    <div className="col-3">
        <label htmlFor="feedback" className="form-label">Feedback</label>
        <textarea id="feedback" name="feedback" className="form-control" rows="3" placeholder="Add feedback" defaultValue={ivrdata.feed}></textarea>
    </div>

    {/* --- Sticky Footer --- */}
    <div className='col-12' style={{
        padding: "7px 20px",
        textAlign: "right",
        position: "fixed",
        bottom: 0,
        right: 0,
        background: "#fff",
        boxShadow: "-4px -4px 4px darkgrey",
    }}>
        <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{ marginRight: '20px', display: 'none' }} />
        <button type="submit" className="btn btn-primary">Submit</button>
    </div>
</div>

 </form>

      </div>
    </div>
</div>

<div className="main-content app-content">

 <div className="container-fluid">

  {/* Page Header — outside the card */}
  <div className="mt-4 mb-3">

    {/* Top row: breadcrumb + back button */}
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'14px', flexWrap:'wrap', gap:'10px' }}>

      {/* macOS Finder style breadcrumb */}
      <div style={{ display:'flex', alignItems:'center', gap:'2px', background:'#f1f5f9', borderRadius:'10px', padding:'5px 10px', border:'1px solid #e2e8f0' }}>
        {/* Line Up — navigates to main lineup page */}
        <button
          onClick={() => aidtype === '113' ? navigate(-2) : navigate(`/admin/lineup/${aidtype}`)}
          style={{ display:'inline-flex', alignItems:'center', gap:'5px', background:'none', border:'none', cursor:'pointer', padding:'4px 8px', borderRadius:'7px', fontSize:'0.82rem', fontWeight:500, color:'#334155', transition:'background 0.15s' }}
          onMouseEnter={e => e.currentTarget.style.background='#e2e8f0'}
          onMouseLeave={e => e.currentTarget.style.background='none'}
        >
          <FormatListBulleted sx={{ fontSize:'0.95rem', color:'#3b82f6' }} />
          Line Up
        </button>

        <KeyboardArrowRight sx={{ fontSize:'1rem', color:'#94a3b8' }} />

        {/* Candidate Line Up / Selected Candidates — goes back 1 page */}
        <button
          onClick={() => navigate(-1)}
          style={{ display:'inline-flex', alignItems:'center', gap:'5px', background:'none', border:'none', cursor:'pointer', padding:'4px 8px', borderRadius:'7px', fontSize:'0.82rem', fontWeight:500, color:'#334155', transition:'background 0.15s' }}
          onMouseEnter={e => e.currentTarget.style.background='#e2e8f0'}
          onMouseLeave={e => e.currentTarget.style.background='none'}
        >
          <PeopleAltOutlined sx={{ fontSize:'0.95rem', color:'#10b981' }} />
          {aidtype === '113' ? 'Selected Candidates' : 'Candidate Line Up'}
        </button>

        <KeyboardArrowRight sx={{ fontSize:'1rem', color:'#94a3b8' }} />

        {/* Req. ID — goes back 1 page (to candidate details page) */}
        {metaData.require && (
          <>
            <button
              onClick={() => navigate(-1)}
              style={{ display:'inline-flex', alignItems:'center', gap:'5px', background:'none', border:'none', cursor:'pointer', padding:'4px 8px', borderRadius:'7px', fontSize:'0.82rem', fontWeight:500, color:'#334155', transition:'background 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.background='#e2e8f0'}
              onMouseLeave={e => e.currentTarget.style.background='none'}
            >
              <AssignmentOutlined sx={{ fontSize:'0.95rem', color:'#8b5cf6' }} />
              {metaData.require}
            </button>
            <KeyboardArrowRight sx={{ fontSize:'1rem', color:'#94a3b8' }} />
          </>
        )}

        {/* Candidates — current, not clickable */}
        <span style={{ display:'inline-flex', alignItems:'center', gap:'5px', padding:'4px 8px', borderRadius:'7px', fontSize:'0.82rem', fontWeight:600, color:'#1e293b', background:'#ffffff', border:'1px solid #cbd5e1' }}>
          <PeopleAltOutlined sx={{ fontSize:'0.95rem', color:'#10b981' }} />
          Candidates
        </span>
      </div>

      {/* Back button — bigger */}
      <button
        className="btn btn-primary"
        onClick={() => navigate(-1)}
        style={{ display:'inline-flex', alignItems:'center', gap:'6px', fontWeight:500, padding:'8px 20px', fontSize:'0.9rem' }}
      >
        <ArrowBackIosNew sx={{ fontSize:'0.85rem' }} />
        Back
      </button>
    </div>

    {/* Page title */}
    <h4 className="fw-semibold mb-2" style={{ fontSize:'1.25rem', color:'#1e293b' }}>{aidtype === '113' ? 'Selected Candidates' : 'Line Up Candidates'}</h4>

    {/* Info chips */}
    <div style={{ display:'flex', flexWrap:'wrap', gap:'8px' }}>
      {metaData.require && (
        <span style={{ display:'inline-flex', alignItems:'center', gap:'4px', background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:'6px', padding:'4px 12px', fontSize:'0.78rem', color:'#475569' }}>
          <span style={{ fontWeight:600, color:'#334155' }}>Req. ID</span> {metaData.require}
        </span>
      )}
      {metaData.appname && (
        <span style={{ display:'inline-flex', alignItems:'center', gap:'4px', background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:'6px', padding:'4px 12px', fontSize:'0.78rem', color:'#475569' }}>
          <span style={{ fontWeight:600, color:'#334155' }}>Client</span> {metaData.appname}
        </span>
      )}
      {metaData.jobtitle && (
        <span style={{ display:'inline-flex', alignItems:'center', gap:'4px', background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:'6px', padding:'4px 12px', fontSize:'0.78rem', color:'#475569' }}>
          <span style={{ fontWeight:600, color:'#334155' }}>Job</span> {metaData.jobtitle}
        </span>
      )}
      {metaData.location && (
        <span style={{ display:'inline-flex', alignItems:'center', gap:'4px', background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:'6px', padding:'4px 12px', fontSize:'0.78rem', color:'#475569' }}>
          <span style={{ fontWeight:600, color:'#334155' }}>Location</span> {metaData.location}
        </span>
      )}
      {metaData.recname && (
        <span style={{ display:'inline-flex', alignItems:'center', gap:'4px', background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:'6px', padding:'4px 12px', fontSize:'0.78rem', color:'#475569' }}>
          <span style={{ fontWeight:600, color:'#334155' }}>Recruiter</span> {metaData.recname}
        </span>
      )}
      <span style={{ display:'inline-flex', alignItems:'center', gap:'4px', background:'#eff6ff', border:'1px solid #bfdbfe', borderRadius:'6px', padding:'4px 12px', fontSize:'0.78rem', color:'#1d4ed8', fontWeight:600 }}>
        {total} Candidates
      </span>
    </div>
  </div>

<div className="row">
            <div className="col-xxl-12 col-xl-12 ">
              <div className="card custom-card">
                <div className="card-header" style={{ paddingBottom: '12px', alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    {selectedRows.length > 0 && (
                      <button
                        className="btn btn-primary"
                        style={{ padding: '10px 24px', fontSize: '1rem', fontWeight: 600 }}
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModalFullscreen"
                        onClick={() => setBulkFormData({ interviewStatus: '', interviewTime: '', joinStatus: '', joinTime: '' })}
                      >
                        Update Status
                      </button>
                    )}
                  </div>
                  <div className="input-group" style={{ width: '260px' }}>
                    <input type="search" className="form-control" placeholder="Search candidates" id="search-member" value={globalFilterText} onChange={(e) => setGlobalFilterText(e.target.value)} />
                  </div>
                </div>
                <div className="card-body" style={{ padding: '0px' }}>

           <TableContainer sx={{ maxHeight: '700px'}}>
                <Table stickyHeader aria-label="requirement tracker table">
                    
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.accessorKey}
                                    sx={{ 
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        p: 2.5,
                                        fontSize: '0.85rem', 
                                        verticalAlign: 'top',
                                    }}>
                                    <ColumnHeaderWithFilter
                                        column={column}
                                        orderBySelector={orderBySelector}
                                        order={order}
                                        handleRequestSort={handleRequestSort}
                                        columnFilters={columnFilters}
                                        setColumnFilters={setColumnFilters}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

<TableBody>
    {processedData.map((row, index) => {
      const isSelected = selectedRows.includes(row.id);
       return (
            <TableRow
                key={index}
                onClick={() => isRowSelectable(row) && handleRowSelect(row.id, !isSelected)}
                sx={{
                    cursor: isRowSelectable(row) ? 'pointer' : 'default',
                    backgroundColor: isSelected ? "#d0ebff" : 'inherit',
                    '&:hover': {
                        backgroundColor: isSelected ? "#a3d3ff" : (isRowSelectable(row) ? '#f5f5f5' : 'inherit'),
                    }
                }}
            >
            {columns.map((column) => {
                let cellContent;
                const cellWidth = column.size ? column.size : 150;

                if (column.Cell) {
                    cellContent = column.Cell({ row: { original: row } });
                }
                // 2. Handle specific accessorKeys with custom logic (like 'rid')
                else {
                    switch (column.accessorKey) {
                        case 'rid':
                            cellContent = <RenderReqIdCell row={row} />; 
                            break;
                        
                        default:
                            // 3. Default rendering for all other columns (campid, name, mobile, designation, etc.)
                            const value = column.selector ? column.selector(row) : null;
                            cellContent = value;
                            break;
                    }
                }

                return (
                    <TableCell 
                        key={column.accessorKey}
                        sx={{ p: 1.5, fontSize: '0.875rem',minWidth:cellWidth,width:cellWidth}}>
                        {cellContent}
                    </TableCell>
                );
            })}
        </TableRow>
   );
    })}
    {/* Empty state if no data */}
    {processedData.length === 0 && (
        <TableRow>
            <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
                <Typography color="textSecondary" variant="body1">
                    No matching found in the current filters.
                </Typography>
            </TableCell>
        </TableRow>
    )}
</TableBody>
               
            </Table>
            </TableContainer>
          
                </div>
              </div>

            </div>
          </div>

</div></div>

</>
);
}
export default LineCandidate;
